import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { goToNextStep, goToStepIndex } from "../features/journey";
import AudioFlower from "../common/components/AudioFlower";
import Button from "../common/components/Button";

interface OffRampProps {
  children: React.ReactNode;
}

const OffRamp = ({ children }: OffRampProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <div className="off-ramp">
      <div>{children}</div>
      <div className="off-ramp-flower">
        <AudioFlower animate opacity={0.35} />
        <Button onClick={() => dispatch(goToNextStep())}>
          {t("continue")}
        </Button>
      </div>
      <Button
        className="text-link"
        onClick={() => dispatch(goToStepIndex("Jewel Light Look"))}
      >
        {t("Skip and leave early")}
      </Button>
    </div>
  );
};

export default OffRamp;
